import { getFirstDayOfBirthdayMonthFromEmployeeId, getLatestDate } from '@fora-monorepo/date-utils';
import { MIN_AGE_STARTDATE } from '@fora-monorepo/employer-my-pages-input-validation';
import { trackException } from '@fora-monorepo/webapp-analytics';

export const getMarkupStartDateRangeMin = (
  monthlyReportingReleaseDate: string,
  currentAgreementValidFromDate: string | null,
  employeeId?: string,
  employmentStartDate?: string,
  // TODO: Remove when the start date of the first employment period becomes editable.
  nonEditableStartDate?: string
) => {
  const datesToCompare = [monthlyReportingReleaseDate];

  if (currentAgreementValidFromDate) {
    datesToCompare.push(currentAgreementValidFromDate);
  } else {
    trackException(new Error('No current agreement or insuranceAgreementValidFromDate'));
  }

  if (employeeId) {
    // First day of the month they turn 13 (MIN_AGE_STARTDATE)
    const minAgeRestrictionDate = getFirstDayOfBirthdayMonthFromEmployeeId(employeeId, MIN_AGE_STARTDATE);
    datesToCompare.push(minAgeRestrictionDate);
  }

  if (employmentStartDate) {
    datesToCompare.push(employmentStartDate);
  }
  // TODO: Remove when the start date of the first employment period becomes editable.
  if (nonEditableStartDate) {
    datesToCompare.push(nonEditableStartDate);
  }

  return getLatestDate(datesToCompare);
};
